'use strict';
import template from './mx-side-panel-ui-actions.html';

angular.module('mx.SolutionBuilderAgent').component('mxSidePanelUiActions', {
	bindings: {
		uiActions: '<',
		view: '<',
	},
	controller: MxSidePanelUiActionsCtrl,
	controllerAs: 'vm',
	template: template,
});

MxSidePanelUiActionsCtrl.$inject = [
	'$scope',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
];

function MxSidePanelUiActionsCtrl($scope, widgetManager, sidePanelService, personalizationService, dialogOpener) {
	const vm = this;
	vm.alternativeViews = [];

	vm.$onChanges = (changes) => {
		if (changes.view) {
			updateAlternativeViews(changes.view.currentValue);
		}
	};

	vm.handleClick = handleClick;
	vm.selectAlternativeView = selectAlternativeView;

	function handleClick(selectedUiAction) {
		selectedUiAction.handler.call(vm.view);
	}

	function selectAlternativeView(selectedView) {
		vm.alternativeViews.forEach((view) => (view.isChecked = selectedView === view));
		openAlternativeView(selectedView);
	}

	async function updateAlternativeViews(view) {
		vm.alternativeViews = [];

		if (!view) {
			return;
		}

		const views = await widgetManager.getAlternativeViews(vm.view);
		if (views.length < 2) {
			return;
		}

		vm.alternativeViews = views.map((view) => ({
			id: view.Id,
			label: view.Name,
			name: view.Name,
			isChecked: vm.view.widgetId === view.Id,
			purpose: view.Purpose || 0,
		}));

		$scope.$evalAsync();
	}

	function openAlternativeView(view) {
		switch (vm.view.dialogType) {
			case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview:
				sidePanelService.closeView(vm.view);
				personalizationService.saveDefaultPreviewId(vm.view.context._type, view.id);
				dialogOpener.openPreview(
					{
						_id: vm.view.context._id,
						_type: vm.view.context._type,
					},
					{ widgetId: view.id }
				);
				break;
			case mx.SolutionBuilderAgent.ContentWidgetDialogAction.New:
				sidePanelService.closeView(vm.view);
				personalizationService.saveDefaultNewDialogId(vm.view.context._type, view.id);
				if (view.purpose === mx.SolutionBuilderAgent.ContentWidgetDialogPurpose.CreateAndEdit) {
					personalizationService.saveDefaultEditDialogId(vm.view.context._type, view.id);
				}
				dialogOpener.openNewDialog(vm.view.context._type, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, view.id);
				break;
			case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit:
				sidePanelService.closeView(vm.view);
				personalizationService.saveDefaultEditDialogId(vm.view.context._type, view.id);
				if (view.purpose === mx.SolutionBuilderAgent.ContentWidgetDialogPurpose.CreateAndEdit) {
					personalizationService.saveDefaultNewDialogId(vm.view.context._type, view.id);
				}
				dialogOpener.openEditDialog(vm.view.context, undefined, undefined, undefined, { widgetId: view.id });
				break;
		}
	}
}
